import { Component, Input, OnInit } from '@angular/core';
import { LazyLoadEvent, MessageService, MenuItem } from 'primeng/api';
import { AppDataService, XpressPaymentTransactionService } from 'app/services';
import { XpressDeliveryStatus } from 'app/models';
import * as moment from 'moment';
import { Utils } from 'app/utils';
import { AppComponent } from 'app/app.component';
import { TableLazyLoadEvent } from 'primeng/table';


@Component({
    selector: 'partner-finance-transactions',
    templateUrl: './partner-finance-transactions.component.html',
    styleUrls: ['./partner-finance-transactions.component.scss',
        '../../../../../styles/style-layout.scss'],
    providers: [MessageService]
})
export class PartnerFinanceTransactionsComponent implements OnInit {
    @Input()
    public menuPermissionActive!: string;

    public isMerchant: boolean = false;
    public merchantId: number = 0;

    //---------------Transactions----------------------
    public transactions: any = null;
    public transactionCols: any[] = [
        { field: 'Id', header: 'TRXN ID', width: '20%' },
        { field: 'CreatedAt', header: 'Date', width: '20%' },
        { field: 'Time', header: 'Time', width: '20%' },
        { field: 'CustomerName', header: 'Customer Name', width: '20%' },
        { field: 'Spend', header: 'Spend', width: '20%' },
        { field: 'ServiceText', header: 'Service', width: '20%' },
        { field: 'StatusText', header: 'Status', width: '20%' }
    ];
    // Grid settings
    public rowsPerPage: number = 50;
    public rowsPerPageOptions: Array<number> = [50, 100, 500, 1000];
    public totalRecords: number = -1;

    public first: number = 0;
    public sortField: string | string[] = '';
    private sortOrder: number = 1;

    public filter: {
        searchName: string;
    } = { searchName: '' };
    private searchTimer: number = 0;

    public loading: boolean = false;

    public filterObj: any = {};

    public transactionId: number = 0;
    public showPartnerFinanceTransactionDetailSideBar: boolean = false;
    public visiblePartnerFinanceTransactionFilter: boolean = false;

    constructor(private messageService: MessageService, public appData: AppDataService,
        public xpressPaymentTransactionService: XpressPaymentTransactionService, public app: AppComponent) {
        this.merchantId = parseInt(this.appData.authData.MerchantId, 10);
        this.isMerchant = this.appData.isMerchant();
    }

    ngOnInit(): void {
    }

    public handleTranzactionLazyLoad(event: TableLazyLoadEvent): void {
        const skip = event.first ? event.first : 0;

        if (event.rows) {
            this.rowsPerPage = event.rows;
        }

        if (!event.sortField) {
            this.sortField = 'Id';
            this.sortOrder = -1; // Desc
        }
        else {
            this.sortField = event.sortField;
            this.sortOrder = event.sortOrder ? event.sortOrder : 1;
        }

        this.getMerchantTransactions(skip, this.filterObj);
    }
    public getMerchantTransactions(skip: number, filterObj: any) {
        this.filterObj = filterObj;

        const dto = {
            MerchantId: this.merchantId,
            Skip: skip,
            Take: this.rowsPerPage,
            SortField: this.sortField,
            SortOrder: this.sortOrder,
            SearchName: this.filter.searchName,
            StartedAt: this.filterObj.StartedAt,
            EndedAt: this.filterObj.EndedAt,
            TimeZoneOffset: Utils.getTimezoneOffset(),
            StatusId: this.getDeliveryOrderStatus(this.filterObj.Status)
        };

        this.loading = true;

        this.xpressPaymentTransactionService.getTransactionsByMerchantAdmin(dto, this.messageService)
            .then(data => {
                if (!data.Success) {
                    this.loading = false;
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }
                this.transactions = data.Items;
                if (data.Items !== null) {
                    this.transactions = data.Items.map((x: any) => {
                        x.Spend = '₱ ' + x.Spend;
                        x.Time = moment(Utils.utcToLocalDate(x.CreatedAt)).format('hh:mm');
                        x.CreatedAt = moment(x.CreatedAt).format('MMM Do YY');
                        return x;
                    });
                }
                this.first = skip;
                this.totalRecords = data.TotalRecords;
                this.loading = false;
            })
            .catch(err => {
                this.loading = false;
                throw err;
            });
    }

    public getDeliveryOrderStatus(status: string) {
        if (status === 'Pending') {
            return XpressDeliveryStatus.New;
        }
        else if (status === 'Cancelled') {
            return XpressDeliveryStatus.Canceled;
        }
        else if (status === 'Completed') {
            return XpressDeliveryStatus.Completed;
        }

        return null;
    }

    public handleFilterChange(): void {
        if (this.searchTimer) {
            window.clearTimeout(this.searchTimer);
        }

        this.searchTimer = window.setTimeout(() => {
            this.getMerchantTransactions(0, this.filterObj);
            this.searchTimer = 0;
        }, 1500);
    }

    public openPartnerFinanceTransactionDetailSideBar(transactionId: number) {
        this.transactionId = transactionId;
        this.showPartnerFinanceTransactionDetailSideBar = true;
    }
    changedShowPartnerFinanceTransactionDetailSideBarEmit(value: boolean) {
        this.showPartnerFinanceTransactionDetailSideBar = value;
    }

    public openPartnerFinanceTransactionFilterSideBar() {
        this.visiblePartnerFinanceTransactionFilter = true;
    }
    changedShowPartnerFinanceTransactionFilterSideBarEmit(value: boolean) {
        this.visiblePartnerFinanceTransactionFilter = value;
    }
}
